<p>Site em contrução</p>
<p>Estou desenvolvendo uma rede social para pessoas que gostam de dança de salão. Siga no <a
        href="https://www.instagram.com/duodance.app/">instagram</a> para ser notificado dos desenvolvimentos.</p>
<router-outlet />